import { TFunction } from "i18next";

export const interpolateSystemMessage = (
  content: string,
  data: Record<string, any> | null | undefined,
  t: TFunction
): string => {
  return t(content, { ...(data || {}), keySeparator: false });
};
